import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../../components/global/Button';
import QRIcon from '../../../../../../../components/icons/QRIcon';
import IntroSlideIcon from '../../../../../../../components/icons/IntroSlideIcon';
import TickerTapeIcon from '../../../../../../../components/icons/TickerTapeIcon';
import IntroSlideSelectModal, {
  INTRO_SLIDE_SELECT_MODAL,
} from './IntroSlideSelectModal';
import QRCodeInsertModal, { QR_CODE_INSERT_MODAL } from './QRCodeInsertModal';
import TickerTapeInsertModal, {
  TICKER_TAPE_INSERT_MODAL,
} from './TickerTapeInsertModal';
import useOpenModal from '../../../../../../../hooks/useOpenModal';

const propTypes = {
  visible: PropTypes.bool,
  slideshow: PropTypes.shape({
    id: PropTypes.string,
  }),
  qrCode: PropTypes.shape({
    url: PropTypes.string,
    withLogo: PropTypes.bool,
    withCallout: PropTypes.bool,
    reviewPhotos: PropTypes.bool,
  }),
  tickerTape: PropTypes.shape({
    message: PropTypes.string,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
  }),
  onInsertIntroSlide: PropTypes.func.isRequired,
  onUpdateQRCode: PropTypes.func.isRequired,
  onInsertTickerTape: PropTypes.func.isRequired,
};

const SecondaryElementsView = ({
  visible,
  albumId,
  qrCode,
  tickerTape,
  onInsertIntroSlide,
  onUpdateQRCode,
  onInsertTickerTape,
}) => {
  const openModal = useOpenModal();
  if (!visible) {
    return null;
  }

  return (
    <Fragment>
      <div className="secondary-elements-view-container">
        <Button
          className="elements-button"
          onClick={() => openModal(INTRO_SLIDE_SELECT_MODAL)}
        >
          <IntroSlideIcon />
          <span>Cover slide</span>
        </Button>
        <Button
          className="elements-button"
          onClick={() =>
            openModal(QR_CODE_INSERT_MODAL, {
              enabled: !!qrCode.isEnabled,
              insertCallout: true,
              includeLogo: !!qrCode?.withLogo,
              reviewPhotos: !!qrCode?.withReviewPhotos,
            })
          }
        >
          <QRIcon />
          <span>QR Code</span>
        </Button>
        <Button
          className="elements-button"
          onClick={() =>
            openModal(TICKER_TAPE_INSERT_MODAL, {
              text: tickerTape?.message ?? '',
              color: tickerTape?.color,
              backgroundColor: tickerTape?.backgroundColor,
            })
          }
        >
          <TickerTapeIcon />
          <span>
            Ticker tape <br /> banner
          </span>
        </Button>
      </div>
      <IntroSlideSelectModal onInsertIntroSlide={onInsertIntroSlide} />
      <QRCodeInsertModal albumId={albumId} onUpdateQRCode={onUpdateQRCode} />
      <TickerTapeInsertModal onInsertTickerTape={onInsertTickerTape} />
    </Fragment>
  );
};

SecondaryElementsView.propTypes = propTypes;

export default SecondaryElementsView;
